import { Dispatch, SetStateAction, useState } from 'react';

interface UseModalStateResult {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onOpen: () => void;
  onClose: () => void;
  onToggle: () => void;
}

function useModalState(defaultValue = false): UseModalStateResult {
  const [open, setOpen] = useState(defaultValue);

  const onOpen = (): void => {
    setOpen(true);
  };

  const onClose = (): void => {
    setOpen(false);
  };

  const onToggle = (): void => {
    setOpen((prev) => !prev);
  };

  return {
    open,
    setOpen,
    onOpen,
    onClose,
    onToggle,
  };
}

export default useModalState;
